import Axios from "axios";

export class ReferenciaPersonalService {

    getLista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/referencia-personal/lista?${queryParams}`).then(res => res.data);
    }

    nuevo(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/trust/referencia-personal/nuevo`, data).then(res => res.data);
    }

    editar(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/trust/referencia-personal/editar`, data).then(res => res.data);
    }

    consultar(id) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/referencia-personal/consulta/${id}`).then(res => res.data);
    }

    delete(id) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/trust/referencia-personal/eliminar/${id}`).then(res => res.data);
    }
}